import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/supplier-products`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/supplier-products/${id}?include=supplier,product`, options)
    .then((response) => {
      let supplierProduct = jsona.deserialize(response.data);
      delete supplierProduct.links;
      return supplierProduct;
    });
}

function add(supplierProduct) {
  const payload = jsona.serialize({
    stuff: supplierProduct,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/supplier-products`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(supplierProduct) {
  const payload = jsona.serialize({
    stuff: supplierProduct,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/supplier-products/${supplierProduct.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/supplier-products/${id}`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
};
